<template>
  <div class="embed" v-html="videoObj.html"></div>
</template>

<script>
import axios from 'axios'

export default {
  name: 'VimeoEmbed',

  props: {
    videoUrl: {
      type: String,
      required: true
    }
  },

  data() {
    return {
      videoObj: []
    }
  },

  created() {
    this.getVideobyUrl(this.videoUrl)
  },

  methods: {
    embedUrl(video) {
      return `https://player.vimeo.com/video/${video.video_id}?title=0&byline=0&portrait=0`
    },

    getVideobyUrl(url) {
      axios.get('https://vimeo.com/api/oembed.json?url='+url)
      .then(response => {
        let videoResp = response.data;

        if (videoResp.video_id) {
          this.videoObj = videoResp;
        }
      })
      .catch(e => {
        console.error(e);
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// _js/components/VimeoEmbed.vue